import { useState } from 'react'
import { LANGS, useI18n } from '../i18n'

export function LanguageChooser() {
  const { lang, setLang } = useI18n()
  const [open, setOpen] = useState(false)
  const current = LANGS.find((l) => l.code === lang)!

  return (
    <div className="relative">
      <button
        onClick={() => setOpen((o) => !o)}
        aria-label="Choose language"
        aria-expanded={open}
        className="flex h-10 items-center gap-2 rounded-full border border-brand-200 dark:border-brand-700 px-3 text-sm font-semibold transition hover:bg-brand-100/60 dark:hover:bg-brand-800/60"
      >
        <span className="text-base leading-none">{current.flag}</span>
        <span className="hidden sm:inline">{current.code.toUpperCase()}</span>
        <span className="text-xs opacity-60">▾</span>
      </button>

      {open && (
        <>
          <button
            className="fixed inset-0 z-40 cursor-default"
            aria-hidden
            tabIndex={-1}
            onClick={() => setOpen(false)}
          />
          <div className="absolute right-0 z-50 mt-2 w-44 overflow-hidden rounded-2xl border border-brand-100 dark:border-brand-700 bg-white dark:bg-brand-800 shadow-lift">
            {LANGS.map((l) => (
              <button
                key={l.code}
                onClick={() => {
                  setLang(l.code)
                  setOpen(false)
                }}
                className={`flex w-full items-center gap-3 px-4 py-2.5 text-left text-sm transition hover:bg-brand-100/70 dark:hover:bg-brand-700/60 ${
                  l.code === lang ? 'font-bold text-brand-700 dark:text-brand-200' : 'font-medium'
                }`}
              >
                <span className="text-base">{l.flag}</span>
                {l.label}
                {l.code === lang && <span className="ml-auto text-brand-600 dark:text-brand-300">✓</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  )
}
